import { Scale } from "../../../utils/Scale"
import { Videos } from "../../../utils/Videos"
import { TobaccoTourMolecule } from "../TobaccoTourTypes"
import { ActivityBackground } from "./ActivitiesBackground"
import { TobaccoTourInteractiveScreen } from "./TobaccoTourInteractiveScreen"

export class TobaccoTourActivityScreen {
    static playVideo = (
        game: Phaser.Game,
        video: string,
        onComplete: () => void,
    ) => {
        const background = TobaccoTourActivityScreen.displayScreenBackground(
            game,
            game.add.group(),
            async () => {
                const videoPlayer = await Videos.add(game, video, {
                    x: Scale.x(0.215),
                    y: Scale.y(0.203),
                    onException: () => {
                        onComplete()
                        background.close()
                        videoPlayer.destroy()
                    },
                    onComplete: () => {
                        onComplete()
                        background.close()
                        videoPlayer.destroy()
                    },
                })
            },
        )
    }

    static displayInteractiveScreen = (
        game: Phaser.Game,
        activityBackground: string,
        molecules: Array<TobaccoTourMolecule>,
        onComplete: () => void,
        audio?: string,
        video?: string,
    ) => {
        if (audio) {
            new TobaccoTourInteractiveScreen(
                game,
                activityBackground,
                molecules,
                onComplete,
                audio,
            )
        } else if (video) {
            new TobaccoTourInteractiveScreen(
                game,
                activityBackground,
                molecules,
                onComplete,
                undefined,
            )
        }
    }

    static displayScreenBackground = (
        game: Phaser.Game,
        group: Phaser.Group,
        onComplete: () => void,
        otherBackground?: string,
    ): ActivityBackground => {
        const background = otherBackground
            ? new ActivityBackground(game, group, otherBackground)
            : new ActivityBackground(game, group)
        background.open(onComplete)
        return background
    }
}
